import React from 'react';
import { Avatar, AvatarSize } from '@/modules/Avatar';
import { LegacyIcon } from '@/modules/LegacyIcon';
import type { LegacyIconName } from '@/shared/types/legacyIcon';
import type { LegacyVisualSlotType } from '@/shared/types/legacyButton';
import { IconFontColor, ButtonColors } from '@/shared/types/types';
import { getIconFontColor } from '@/modules/InnerButton/utils/colorUtils';
import { isLikelyUrl } from '../utils/legacySlotUrl';

export interface LegacyButtonIconProps {
  icon: LegacyVisualSlotType | React.ReactElement;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
  color?: ButtonColors;
  colorIcon?: string;
  classNameIcon?: string;
  strokeWidth?: number;
  /** @deprecated Con `theme="icon"` el clic se delega al icono. */
  theme?: 'solid' | 'icon';
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement | HTMLDivElement>) => void;
  onClickIcon?: (e: React.MouseEvent<HTMLDivElement>) => void;
  iconDuotonePrimary?: IconFontColor;
  iconDuotoneSecondary?: IconFontColor;
  iconDuotoneOpacityPrimary?: number;
  iconDuotoneOpacitySecondary?: number;
}

export const LegacyButtonIcon: React.FC<LegacyButtonIconProps> = ({
  icon,
  size,
  color,
  colorIcon,
  classNameIcon,
  theme,
  onClick,
  onClickIcon,
  iconDuotonePrimary,
  iconDuotoneSecondary,
  iconDuotoneOpacityPrimary,
  iconDuotoneOpacitySecondary,
}) => {
  if (React.isValidElement(icon)) {
    return <>{icon}</>;
  }

  if (typeof icon === 'string' && isLikelyUrl(icon)) {
    return <Avatar type="people" src={icon} className={classNameIcon} size={'xxs' as AvatarSize} />;
  }

  const legacySize = size === 'xxs' ? 'xs' : 'sm';

  return (
    <LegacyIcon
      className={classNameIcon}
      name={icon as LegacyIconName}
      size={legacySize}
      color={getIconFontColor(color, colorIcon as IconFontColor | undefined) as IconFontColor}
      onClick={
        theme === 'icon'
          ? (onClick as (e: React.MouseEvent<HTMLDivElement>) => void) || onClickIcon
          : undefined
      }
      colorDuotonePrimary={iconDuotonePrimary}
      colorDuotoneSecondary={iconDuotoneSecondary}
      opacityDuotonePrimary={iconDuotoneOpacityPrimary}
      opacityDuotoneSecondary={iconDuotoneOpacitySecondary}
    />
  );
};

LegacyButtonIcon.displayName = 'LegacyButtonIcon';
